// Pure helpers for typing a DD/MM/YYYY date. No imports, so Node can test them
// (test/js/date_entry.test.mjs); ds_form_date_input.js uses them in onText.

const MASKABLE = /^(?:\d{0,2}|\d{2}\/?\d{0,2}|\d{2}\/?\d{2}\/?\d*)$/;

// Inserts the DD/MM/YYYY slashes into text that is nothing but digits plus
// slashes in the mask's own positions, so the digits-only numeric keypad can
// enter a date. Returns null for any other text (`5/10/2026`, `5-10-2026`,
// ISO, letters): that is left exactly as typed. No trailing slash is added, so
// `0510` reads `05/10` and backspace never has an auto-inserted slash to eat.
export const maskAuDate = (text) => {
  const s = String(text);
  if (!MASKABLE.test(s)) return null;
  const d = s.replace(/\//g, "").slice(0, 8);
  let out = d.slice(0, 2);
  if (d.length > 2 || (d.length === 2 && /^\d{2}\//.test(s))) out += `/${d.slice(2, 4)}`;
  if (d.length > 4 || (d.length === 4 && s.endsWith("/"))) out += `/${d.slice(4)}`;
  return out;
};

// Typing an ISO date one key at a time: `2027` was masked to `20/27` before the
// "-" showed it was ISO. Takes the mask's own slashes back out (`20/27-` becomes
// `2027-`). Any other text is returned unchanged.
export const unmaskIso = (text) => String(text).replace(/^(\d{2})\/(\d{2})-/, "$1$2-");

// True while a date is still being typed: a year with fewer than 4 digits, fewer
// than 8 bare digits, or the start of an ISO date. The empty string is not
// pending (an empty field stays blank, as before).
export const isPartialAuDate = (text) => {
  const t = String(text).trim();
  if (t === "") return false;
  return (
    /^\d{0,7}$/.test(t) ||
    /^\d{1,2}[/.-](\d{1,2}([/.-]\d{0,3})?)?$/.test(t) ||
    /^\d{4}(-(\d{1,2}(-\d?)?)?)?$/.test(t)
  );
};
